import React, { Component } from 'react';
import { connect } from "react-redux";
import * as actions from "../../../actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFloppyDisk
} from "@fortawesome/free-solid-svg-icons";

class GameOver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      whackamoleScoreList: [],
    };
    this.inputField = React.createRef();
  }

  componentDidMount() {
    this.props.fetchWhackamoleGamesScores();
  }

  render() {
    return (
      <div className="game__game-over" style={{ display: this.props.context.state.gameOver }}>
        <h1 className="game__game-over-header" >GAME OVER!</h1>
        <p className="game__you-scored">You scored {this.props.context.state.score}</p>
        {this.props.context.state.score !== 0 ?
          <>
            <input type="text" placeholder="Enter name here" ref={this.inputField} name="name"  required className="game__you-name" />
            <button className="game__game-over-button" onClick={() => this.submitScore(this.props.context.state.score)}><FontAwesomeIcon icon={faFloppyDisk} size="1x" /></button>
          </>
          :
          ''}
      </div>
    )
  };

  submitScore = (props) => {
    const { addWhackamoleGameScore } = this.props;
    let name = this.inputField.current.value;
    let score = props[0];

    if (name && score) {
      const createdAt = new Date().toString();
      const { whackamoleScoreList } = this.state;
      whackamoleScoreList.push({ createdAt, name, score });
      this.setState({ whackamoleScoreList });
      addWhackamoleGameScore({
        name: name,
        score: score,
        createdAt: createdAt,
      });
      this.inputField.current.value = "";
      this.props.context.state.gameOver = "none";
    }
  };
}

const mapStateToProps = ({ data }) => {
  return {
    data,
  };
};


export default connect(mapStateToProps, actions)(GameOver);